import React from 'react';
import { CheckCircle, Users, MessageSquare, Shield, Target } from 'lucide-react';
import { differentials, images } from '../data/mock';
import { useParallaxSimple } from '../hooks/useParallax';

const iconMap = {
  0: Users,
  1: MessageSquare,
  2: Shield,
  3: Target
};

export const DifferentialsSection = () => {
  const parallaxLeft = useParallaxSimple(0.08);
  const parallaxRight = useParallaxSimple(-0.05);

  return (
    <section id="diferenciais" className="py-16 sm:py-20 lg:py-24 bg-[#f5f1ed] relative overflow-hidden">
      <div
        className="absolute top-0 left-0 w-72 h-72 sm:w-96 sm:h-96 bg-[#d4af37]/8 rounded-full -translate-x-1/2 -translate-y-1/2 blur-3xl pointer-events-none"
        style={parallaxLeft.style}
        aria-hidden
      />
      <div
        className="absolute bottom-0 right-0 w-80 h-80 sm:w-[500px] sm:h-[500px] bg-[#d4af37]/5 rounded-full translate-x-1/2 translate-y-1/2 blur-3xl pointer-events-none"
        style={parallaxRight.style}
        aria-hidden
      />

      <div className="max-w-7xl mx-auto px-5 sm:px-6 lg:px-8 relative z-10">
        <div className="text-center max-w-3xl mx-auto mb-10 sm:mb-14">
          <span className="inline-block text-[#b8962e] text-xs sm:text-sm font-semibold tracking-widest uppercase mb-3 sm:mb-4">
            Por que nos escolher
          </span>
          <h2 className="font-serif text-2xl sm:text-3xl md:text-4xl text-[#0f1f3d] leading-tight mb-4 tracking-tight">
            Diferenciais do Atendimento
          </h2>
          <p className="text-slate-600 leading-relaxed text-sm sm:text-base">
            Nosso compromisso é oferecer um serviço jurídico de excelência, pautado na ética e no respeito ao cliente.
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-3 gap-8 lg:gap-10 xl:gap-12 items-stretch">
          <div className="lg:col-span-1">
            <div className="h-full min-h-[280px] sm:min-h-[360px] lg:min-h-0 lg:sticky lg:top-28 bg-white rounded-2xl border border-slate-200/80 shadow-sm overflow-hidden flex items-end justify-center p-4 sm:p-6">
              <img
                src={images.differentialsPhoto}
                alt="Dra. Jéssica de Paula"
                className="w-full max-h-[min(72vh,520px)] object-contain object-bottom"
              />
            </div>
          </div>

          <div className="lg:col-span-2 grid sm:grid-cols-2 gap-4 sm:gap-5 lg:gap-6">
            {differentials.map((item, index) => {
              const Icon = iconMap[index] || CheckCircle;
              return (
                <div
                  key={item.id}
                  className="group flex gap-4 sm:gap-5 p-6 sm:p-7 bg-white rounded-md border border-slate-200 hover:border-[#d4af37]/35 hover:shadow-md transition-all duration-300"
                >
                  <div className="flex-shrink-0">
                    <div className="w-12 h-12 sm:w-14 sm:h-14 bg-[#f5f1ed] border border-[#d4af37]/20 rounded-xl flex items-center justify-center group-hover:border-[#d4af37]/35 transition-colors duration-300">
                      <Icon className="w-6 h-6 sm:w-7 sm:h-7 text-[#b8962e] stroke-[1.5] group-hover:text-[#d4af37] transition-colors duration-300" />
                    </div>
                  </div>
                  <div className="min-w-0">
                    <h3 className="font-serif text-base sm:text-lg text-[#0f1f3d] font-semibold mb-2 leading-snug group-hover:text-[#b8962e] transition-colors duration-300">
                      {item.title}
                    </h3>
                    <p className="text-slate-500 text-sm leading-relaxed">
                      {item.description}
                    </p>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
};
